/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

/**
 * Card types a participant may set as their Default Payment Account.
 *
 * Expense Cards (`ec`, `pec`) and Spend Cards (`vspc`, `pspc`) never receive
 * a payout, so PPS refuses them as the latest payment method and PASS rejects
 * them at the route with 422. A Stipend Card (`vstc`, `pstc`) is accepted
 * here but receives stipends and micropayments only, so while it is the
 * default any receipt or mileage claim is refused with 422 `PMT-05`.
 */
export type DefaultableCardType =
  (typeof DefaultableCardType)[keyof typeof DefaultableCardType];

export const DefaultableCardType = {
  vc: "vc",
  pc: "pc",
  vstc: "vstc",
  pstc: "pstc",
} as const;
